export default "__VITE_ASSET__8lnMzLjAb2LTrg_7oX19hw__"